import React, { Component } from 'react';
import classnames from "classnames";
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { connect } from "react-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';
import MainHeader from './mainHeader';

import './headersCommon.scss'

class ConflictOfInterestHeader extends Component {
    render() {
        const isOnCheckListPage = this.endsWith(this.props.location.pathname, '/conflictOfInterest');
        const isOnClientListPage = (this.endsWith(this.props.location.pathname, '/client-list') || this.endsWith(this.props.location.pathname, '/client-list/add'));
        const isOnReferenceListPage = (this.endsWith(this.props.location.pathname, '/reference-list') || this.endsWith(this.props.location.pathname, '/reference-list/add'));

        return (<>
            <MainHeader label="LeftPanel.ConfilctOfInterest" {...this.props} />
            {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', {'tinted' :this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    <li className={`tab-link ${isOnCheckListPage ? 'is-active' : ''}`}>
                        <NavLink to={`${this.props.match.url}`} >
                            <Translate id='ConflictOfInterest.CheckList' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnCheckListPage ? "" : "none" }}></div>
                    </li> 
                    <li className={`tab-link ${isOnClientListPage ? 'is-active' : ''}`}>
                        <NavLink to={`${this.props.match.url}/client-list`}>
                            <Translate id='ConflictOfInterest.ClientList' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnClientListPage ? "" : "none" }}></div>
                    </li>

                    <li className={`tab-link ${isOnReferenceListPage ? 'is-active' : ''}`}>
                        <NavLink to={`${this.props.match.url}/reference-list`}>
                            <Translate id='ConflictOfInterest.ReferenceList' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnReferenceListPage ? "" : "none" }}></div>
                    </li>
                </ul>
            </div>}
        </>)
    }

    isOnResultsPage = () => this.isActiveLink('/results-list') || this.isActiveLink('/result');
    isActiveLink = (item) => this.props.location.pathname.indexOf(item) >= 0;
    endsWith = (str, suffix) => isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;
}

export default withRouter(connect(state => ({ ...state, search: state.search }))(ConflictOfInterestHeader));